<template>
    <!-- 注意：我这里是Vue3，所以最外层没有套一个div盒子 -->
    <!-- element-plus -->
    <h1>element-plus：</h1>
    <el-row class="mb-4">
        <el-button disabled>Default</el-button>
        <el-button type="primary" disabled>Primary</el-button>
        <el-button type="success" disabled>Success</el-button>
        <el-button type="info" disabled>Info</el-button>
        <el-button type="warning" disabled>Warning</el-button>
        <el-button type="danger" disabled>Danger</el-button>
    </el-row>


    <!-- ant-design-vue -->
    <h1>ant-design-vue：</h1>
    <div :style="{ background: 'rgb(190, 200, 200)', padding: '26px 16px 16px' }">
        <a-button type="primary" ghost>Primary</a-button>
        <a-button ghost>Default</a-button>
        <a-button type="dashed" ghost>Dashed</a-button>
        <a-button danger ghost>Danger</a-button>
        <a-button type="link" ghost>Link</a-button>
    </div>

</template>
<script>
    export default {
        data() {
            return {
                transition: true,
                timer: null

            }
        },
        mounted() {
            /**
             * @description 监听页面滑动**/
            window.addEventListener('scroll', this.handleScroll);
        },
        methods: {
            /**
             * @description 页面滑动
             * 监听滑动事件，每次进行滑动时，触发动画，添加定时器，1.4s后显示该图标
             * 
             * **/
            handleScroll() {
                this.transition = false;
                if (this.timer) { // 判断是否已存在定时器
                    clearTimeout(this.timer);
                }
                this.timer = setTimeout(() => { // 创建定时器，1.4s后图标回归原位置
                    this.transition = true;
                }, 1000);
            },

        }
    }
</script>
<style scoped>
    div {
        font-size: 60px;
    }

    .main {
        height: 120vh;
    }

    .toAsk {
        width: 88px;
        position: fixed;
        right: 10px;
        bottom: 10vh;
        transition: 0.5s ease-in-out;
    }

    .fixed-transition {
        right: -60px;
        opacity: 0.4;
        transition: 0.5s ease-in-out;
    }

    img {
        max-width: 100%;
    }
</style>